import { render, staticRenderFns } from "./YesValue.vue?vue&type=template&id=10b7fdbc&"
import script from "./YesValue.vue?vue&type=script&lang=js&"
export * from "./YesValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports